import { CollectionName, CollectionVisibility } from "../registry/collection-registry"
import type { CollectionCreateSchema } from "../types/typesense"

export const deAlcoholisedSchema: CollectionCreateSchema = {
  name: CollectionName.DeAlcoholised,
  fields: [
    {
      name: "search_id",
      type: "string",
      facet: false,
      infix: true,
    },
    {
      name: "label",
      type: "string",
      facet: false,
      infix: true,
    },
  ],
  visibility: CollectionVisibility.EC,
}
